export default __webpack_public_path__ + "static/media/butcher3.f931e0ef.png";